import { KNOWN_ROUTES, routeFor, type PageRoute } from "../shared/constants/pageAgentRoutes";
import { FRONTEND_TOOL_CODES, FRONTEND_TOOL_NAMES } from "./frontendToolNames";
import { enumStringNode, isRefusal, refuse, requiredString, type FrontendTool } from "./frontendTool";

const CASE_ID = "caseId";

/** Opens one of the screens the dock knows; the allow-list is the declaration's enum and the executor's check. */
export const navigateToTool: FrontendTool = {
  name: FRONTEND_TOOL_NAMES.navigateTo,
  declaration: () => ({
    name: FRONTEND_TOOL_NAMES.navigateTo,
    description: "Open one of the application's screens. Routes with $caseId need caseId.",
    parameters: {
      type: "object",
      properties: {
        route: enumStringNode(KNOWN_ROUTES),
        [CASE_ID]: { type: "integer", description: "The case to open, for routes that take one." },
      },
      required: ["route"],
    },
  }),
  execute: async (args, env) => {
    const route = requiredString(args, "route");
    if (isRefusal(route)) return route;
    if (!KNOWN_ROUTES.includes(route as PageRoute)) {
      return refuse(FRONTEND_TOOL_CODES.outOfScope, `${route} is not a screen the agent may open.`);
    }
    const caseId = args[CASE_ID];
    if (caseId !== undefined && !Number.isInteger(caseId)) return refuse(FRONTEND_TOOL_CODES.invalidValue, `${CASE_ID} must be an integer.`);
    let path: string;
    try {
      path = routeFor(route as PageRoute, caseId === undefined ? {} : { [CASE_ID]: caseId as number });
    } catch (error: unknown) {
      return refuse(FRONTEND_TOOL_CODES.invalidValue, error instanceof Error ? error.message : String(error));
    }
    await env.navigate(path);
    return { ok: true, route: path };
  },
};
